// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDmHmBkQhz8yqpdmVCHgGbkndYw6ugh04I",
  authDomain: "ytcomments-e6244.firebaseapp.com",
  projectId: "ytcomments-e6244",
  storageBucket: "ytcomments-e6244.firebasestorage.app",
  messagingSenderId: "272914394554",
  appId: "1:272914394554:web:fd87b7d2e99dca27e18183",
  measurementId: "G-KLBZWGDP48"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, analytics, db, auth };
